import React from "react";
import { Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import { PropTypes } from "prop-types";
import { ExtraSmallFab } from "../../Shared/components/Buttons/ExtraSmallFAB";

SkipDayWarningModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  handleUpdateSkipDay: PropTypes.func,
  dayToSkip: PropTypes.string,
  modalTitle: PropTypes.string,
  modalText: PropTypes.string,
  mutatingDates: PropTypes.instanceOf(Set),
};

export default function SkipDayWarningModal(props) {
  const { isOpen, onClose, handleUpdateSkipDay, dayToSkip, modalTitle, modalText, mutatingDates } = props;
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{modalTitle}</Typography>
          <ExtraSmallFab icon={CloseIcon} aria-label="close" onClick={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogText>{modalText}</DialogText>
      </DialogContent>
      <>
        <StyledLine />
      </>
      <ButtonContiner>
        <ActionButton variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </ActionButton>

        <ActionButton variant="contained" color="secondary" disabled={mutatingDates?.has(dayToSkip)} onClick={() => { handleUpdateSkipDay(dayToSkip, true); onClose(); }}>
          Confirm
        </ActionButton>
      </ButtonContiner>
    </Dialog>
  );
}

const StyledLine = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  padding: 0;
  margin: 10px 20px;
`;

const DialogText = styled.p`
  text-align: left;
  font-size: 14px;
  margin: 0;
`;

const DialogTitle = styled.h2`
  font-size: 20px;
  margin: 0px;
  margin-bottom: 10px;
  padding: 20px 20px 0px 20px;
  text-align: left;
  word-break: breakAll;
`;

const ActionButton = styled(Button)`
  width: 49%;
  height: 50px;

  @media (max-width: 503px) {
    width: 100%;
    margin-bottom: 10px !important;
  }
`;

const ButtonContiner = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 20px 20px 20px;
  @media (max-width: 503px) {
    flex-direction: column;
  }
`;
